import { Check, X } from "lucide-react";

const ComparisonSection = () => {
  const features = [
    {
      name: "IA Especializada",
      marketpro: true,
      planilhas: false,
      chatgpt: "Parcial",
      trello: false,
    },
    {
      name: "Planilhas integradas",
      marketpro: true,
      planilhas: "Parcial",
      chatgpt: false,
      trello: false,
    },
    {
      name: "Product DNA",
      marketpro: true,
      planilhas: false,
      chatgpt: false,
      trello: false,
    },
    {
      name: "Gamificação",
      marketpro: true,
      planilhas: false,
      chatgpt: false,
      trello: false,
    },
    {
      name: "Preço acessível",
      marketpro: "R$14,90",
      planilhas: "Variável",
      chatgpt: "R$100+",
      trello: "Gratuito",
    },
    {
      name: "Tudo em um só lugar",
      marketpro: true,
      planilhas: false,
      chatgpt: false,
      trello: "Parcial",
    },
  ];

  const renderCell = (value: boolean | string) => {
    if (value === true) {
      return (
        <div className="flex justify-center">
          <div className="w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
            <Check className="w-5 h-5 text-success" />
          </div>
        </div>
      );
    }
    if (value === false) {
      return (
        <div className="flex justify-center">
          <div className="w-8 h-8 bg-destructive/10 rounded-full flex items-center justify-center">
            <X className="w-5 h-5 text-destructive" />
          </div>
        </div>
      );
    }
    return (
      <div className="text-center text-sm font-medium text-foreground">
        {value}
      </div>
    );
  };

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-4">
            💥 Por que MarketPro Tools?
          </h2>
          <p className="text-xl text-muted-foreground">
            Compare e veja a diferença
          </p>
        </div>

        <div className="max-w-6xl mx-auto overflow-x-auto">
          <div className="bg-card rounded-xl shadow-lg overflow-hidden min-w-[800px]">
            {/* Header */}
            <div className="grid grid-cols-5 bg-muted/50 border-b border-border">
              <div className="p-4 font-semibold text-foreground">Feature</div>
              <div className="p-4 text-center font-semibold text-primary border-l-2 border-primary bg-primary/5">
                MarketPro Tools
              </div>
              <div className="p-4 text-center font-semibold text-muted-foreground">
                Planilhas Avulsas
              </div>
              <div className="p-4 text-center font-semibold text-muted-foreground">
                ChatGPT
              </div>
              <div className="p-4 text-center font-semibold text-muted-foreground">
                Trello/Notion
              </div>
            </div>

            {/* Rows */}
            {features.map((feature, index) => (
              <div
                key={index}
                className="grid grid-cols-5 border-b border-border hover:bg-muted/30 transition-colors"
              >
                <div className="p-4 font-medium text-foreground">
                  {feature.name}
                </div>
                <div className="p-4 border-l-2 border-primary bg-primary/5">
                  {renderCell(feature.marketpro)}
                </div>
                <div className="p-4">{renderCell(feature.planilhas)}</div>
                <div className="p-4">{renderCell(feature.chatgpt)}</div>
                <div className="p-4">{renderCell(feature.trello)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
